import initLangSwitcher from 'components/lang-switcher'
import initPromoPopup from 'components/promo-popup'
import cookieConsent from 'services/cookies-consent'
import { spawnTrackingEventListners } from 'components/tracking-ga-events'

cookieConsent.init()
initLangSwitcher()
initPromoPopup()
spawnTrackingEventListners()
